export function findNumberFromString(str: string): number | null {
  const regex = /\((\d+)\)/; // Regular expression to match the pattern 'seek([number])'
  const match = str.match(regex); // Matching the pattern in the string
  if (match && match[1]) {
    return parseInt(match[1]); // Extracting the captured number and converting it to an integer
  }
  return null; // Return null if the pattern is not found or the number is not present
}
